import { isDevelopment } from "./utils";

export function shouldUseEnglishLocale({ search, localStorageLang, isDevelopmentMode }: { search: string; localStorageLang: string | null; isDevelopmentMode: boolean }): boolean {
  return isDevelopmentMode && (search.includes("lang=en") || localStorageLang == "en");
}

/**
 * Returns true if the english locale should be used in the application.
 */
export function isEnglishLocale(): boolean {
  return shouldUseEnglishLocale({
    search: window.location.search,
    localStorageLang: window.localStorage.getItem("lang"),
    isDevelopmentMode: isDevelopment,
  });
}

export let buildLocale: "en-GB" | "en-US" | "ru-RU";

if (isEnglishLocale()) {
  buildLocale = "en-GB";
} else {
  buildLocale = "ru-RU";
}

// NOTE: To be able to toggle the `buildLocale` from our dev tools.
export function setBuildLocale(newBuildLocale: typeof buildLocale) {
  buildLocale = newBuildLocale;
}
